import type {
  CreateSecret,
  Secret,
  UpdateSecret,
} from "@/schemas/secret.schema";
import type { RequestConfig } from "@/services/api";
import { api } from "@/services/api";

export const secretsApi = {
  async list(config?: RequestConfig) {
    const { data } = await api<Secret[]>("/secrets", config);
    return data;
  },

  async create(payload: CreateSecret, config?: RequestConfig) {
    const { data } = await api.post<Secret>("/secrets", payload, config);
    return data;
  },

  async update(id: string, payload: UpdateSecret) {
    const { data } = await api.patch<Secret>(`/secrets/${id}`, payload);
    return data;
  },

  async remove(id: string) {
    await api.delete(`/secrets/${id}`);
  },

  async clone(id: string, targetProjectId: string) {
    const { data } = await api.post<Secret>(`/secrets/${id}/clone`, {
      project_id: targetProjectId,
    });
    return data;
  },
};
